"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./Popover.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TriggerWrapper = function TriggerWrapper(TriggerComponent, onClick) {
  return /*#__PURE__*/_react["default"].createElement(TriggerComponent, {
    onClick: onClick
  });
};
var baseClass = 'ap-popover';
var Popover = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Popover(props) {
    var _this;
    _classCallCheck(this, Popover);
    _this = _callSuper(this, Popover, [props]);
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.removeListeners();
    });
    _defineProperty(_this, "handleClickOutside", function (e) {
      if (_this.popupRef.contains(e.target)) {
        return;
      }
      _this.toggleShow();
    });
    _defineProperty(_this, "handleKeyDown", function (e) {
      if (e.code === 'Escape') {
        _this.toggleShow();
        e.target.blur();
      }
    });
    _defineProperty(_this, "toggleShow", function () {
      _this.setState({
        show: !_this.state.show,
        popoverLeftOffset: 0
      }, function () {
        // add offset to popover content if it is out of screen
        if (_this.state.show && _this.contentRef && _this.isOutOfScreen()) {
          var popoverLeftOffset = _this.getLeftOffset();
          _this.setState({
            popoverLeftOffset: popoverLeftOffset
          });
        }
        if (_this.state.show) {
          _this.addListeners();
        } else {
          _this.removeListeners();
        }
      });
    });
    _defineProperty(_this, "isOutOfScreen", function () {
      var rect = _this.contentRef.getBoundingClientRect();
      return rect.x + rect.width > window.innerWidth;
    });
    _defineProperty(_this, "getLeftOffset", function () {
      var rect = _this.contentRef.getBoundingClientRect();
      var scrollWidth = 17;
      var leftOffset = window.innerWidth - (rect.x + rect.width);
      var hasVerticalScroll = document.body.scrollHeight > window.innerHeight;
      return hasVerticalScroll ? leftOffset - scrollWidth : leftOffset;
    });
    _defineProperty(_this, "getBEMClasses", function () {
      var classes = [baseClass, _this.props.customClass, _this.props.isMenu && 'popover-menu'];
      return (0, _cssClassesHelper.getBEMClasses)(classes);
    });
    _this.popupRef = null;
    _this.contentRef = null;
    _this.state = {
      show: false,
      popoverLeftOffset: 0
    };
    return _this;
  }
  _inherits(Popover, _React$Component);
  return _createClass(Popover, [{
    key: "addListeners",
    value: function addListeners() {
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        trigger = _this$props.trigger,
        content = _this$props.content,
        drawArrow = _this$props.drawArrow;
      var show = this.state.show;
      var Trigger = TriggerWrapper(trigger, this.toggleShow);
      var bemClasses = this.getBEMClasses();
      var isVisible = bemClasses(show ? 'visible' : 'hidden');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('popover', bemClasses('popover')),
        ref: function ref(_ref2) {
          return _this2.popupRef = _ref2;
        }
      }, Trigger, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(_ref) {
          return _this2.contentRef = _ref;
        },
        className: "".concat(isVisible, " ").concat(bemClasses('content', drawArrow && 'with-arrow'))
      }, show && content));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Popover, "propTypes", {
  trigger: _propTypes["default"].func.isRequired,
  content: _propTypes["default"].element.isRequired,
  drawArrow: _propTypes["default"].bool,
  customClass: _propTypes["default"].string
});
_defineProperty(Popover, "defaultProps", {
  drawArrow: false
});